<script>
  import { onMount } from 'svelte'
  import { request } from '../../helpers/api'
  import TextInput from '../../components/TextInput.svelte'
  import Button from '../../components/Button.svelte'
  import { notEmpty } from '../../helpers/form-validation.js'
  import { clientStore, locationStore, snackBarStore, userStore, peopleStore } from '../../state/store'
  import { t } from '../../i18n/i18n'
  
  const form = {
    name: '',
    address: '',
    assignee: '',
    client: '',
    description: '',
    coordinates: [],
  }

  $: formValid = notEmpty(form.name) &&
                  notEmpty(form.address)

  let placeSearch
  let autocomplete

  onMount(() => {
    initAutocomplete()
  })

  const initAutocomplete = () => {
    autocomplete = new google.maps.places.Autocomplete(
    (autocomplete),
    { types: ['geocode'] }
  )

    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    autocomplete.addListener('place_changed', () => {
      // Get the place details from the autocomplete object.
      form.address = autocomplete.getPlace().formatted_address
      form.coordinates[0] = autocomplete.getPlace().geometry.location.lng()
      form.coordinates[1] = autocomplete.getPlace().geometry.location.lat()
    })
  }

  const submitForm = async () => {
    try {
      // Submit form data
      const response = await request({
        url: `/api/locations`,
        method: 'POST',
        body: JSON.stringify({
          ...form,
          tenant: $userStore.tenant_id
        })
      })

      // Add newly created location to the store
      locationStore.update((locations) => {
        return [
          ...locations,
          response
        ]
      })
      snackBarStore.set({ message: $t['Location Added'], type: 'success' })
    } catch (error) {
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }
  }

</script>

<style>

  select {
    margin-bottom: .5rem;
    width: 100%;
  }

  label {
    display: block;
  }

  .auto-complete {
    display: block;
    width: 100%;
    font: inherit;
    border: 2px solid var(--bg-grey);
    background: var(--off-white);
    padding: .15rem .5rem;
    transition: border-color .1s ease-out;
  }

  textarea {
    width: 100%;
  }

</style>

<form on:submit|preventDefault={submitForm}>
  <label for="Client">{$t['Client']}</label>
  <select 
    name="Client" 
    id="Client" 
    on:input={event => (form.client = event.target.value)}
    value="{form.client}" >
    <option value=''>{$t['Select Client']}</option>
    {#each $clientStore as client, index}
      <option value={client._id}>{client.name}</option>
    {/each}
  </select>
  <TextInput
    id='name'
    label='{$t['Location Name']}'
    validityMessage='{$t['Please enter a Location name']}'
    on:input={event => (form.name = event.target.value)}
    value="{form.name}" />
  
  <div class="form-control">
    <label for="address">{$t.address}</label>
    <input
      type="text"
      id='address'
      class="auto-complete"
      bind:this={autocomplete}
      placeholder=""
    >
  </div>
  <div class="form-control">
    <label for="description">{$t.description}</label>
    <textarea name="description" id="description" cols="30" rows="6" on:input={event => (form.description = event.target.value)}></textarea>
  </div>
    <label for="User">{$t.assignee}</label>
    <select 
      name="Assignee" 
      id="Assignee" 
      on:input={event => (form.assignee = event.target.value)}
      value="{form.assignee}" >
      <option value=''>{$t['Select Assignee']}</option>
      {#each $peopleStore as data, index}
        <option value={data._id}>{data.name}</option>
      {/each}
    </select>
  <Button size='full' type="submit" disabled={!formValid}>
    {$t['Add Location']}
  </Button>
</form>
